export default {
    "QUEST_MISSION_COMPLETE": "QUEST_MISSION_COMPLETE",
    "QUEST_COMPLETE": "QUEST_COMPLETE",
    "QUEST_REDEEM": "QUEST_REDEEM",
    "START_QUEST": "START_QUEST",
    "FETCH_QUEST": "FETCH_QUEST"
}